import { Button, Text, TextField } from 'monday-ui-react-core';
import { useState } from 'react';
import MainService from '../../services/MainService';
import UrlConsts from '../../constants/UrlConstants';
import { sanitizeHtml } from '../../helper/sanitizeHtml';

interface Props {
	createPassComplete: (onTaskComplete: boolean) => void;
	context: any;
}

const FormCreatePassword: React.FC<Props> = ({ context, createPassComplete }) => {
	const [password, setPassword] = useState<string>('');
	const [statusLogin, setStatusLogin] = useState<any>();
	const [signingIn, setSigningIn] = useState<any>();

	function handlePassword(event) {
		setPassword(event);
		if (!event?.length) setStatusLogin({ status: '', text: '' });
	}

	async function handleCreatePassClick() {
		setSigningIn(true);
		MainService.notice('Creating password...', 'info');
		const data = {
			accountId: context?.account?.id,
			boardId: context?.boardId,
			password: password,
		};
		const createPass = await MainService.postNoAuthen(data, UrlConsts.createPassword);
		if (createPass) {
			createPassComplete(true);
			MainService.removeToken();
			MainService.notice('Create password successfully!!!');
		} else {
			MainService.notice('Something went wrong...', 'error');
			createPassComplete(false);
		}

		setSigningIn(false);
	}
	function getSafeStatus(status: any): 'success' | 'error' | undefined {
		const safe = sanitizeHtml(status);
		if (safe === 'success' || safe === 'error') return safe;
		return undefined; // Không hợp lệ thì không truyền gì cả
	}

	return (
		<>
			{context?.isOwner ? (
				<>
					<TextField
						placeholder='Password'
						title='Enter your new password'
						type={TextField.types.PASSWORD}
						wrapperClassName='monday-storybook-text-field_size'
						value={password}
						onChange={(event: string) => handlePassword(event)}
						validation={{
							status: getSafeStatus(statusLogin?.status),
							text: sanitizeHtml(statusLogin?.text),
						}}
					/>
					<div className='text-right mt-5'>
						<Button
							onClick={handleCreatePassClick}
							loading={signingIn}
							className='text-center'>
							Create Password
						</Button>
					</div>
				</>
			) : (
				<>
					<Text
						type={Text.types.TEXT2}
						className='text-red-600 text-2xl text-center'
						ellipsis={false}>
						Access Denied
					</Text>
					<hr className='w-1/2 text-center mt-4 mx-auto'></hr>
					<Text
						type={Text.types.TEXT2}
						className='mt-10 text-xl text-center'
						ellipsis={false}>
						This view requires a new password. Please contact the board owner for more details.
					</Text>
				</>
			)}
		</>
	);
};

export default FormCreatePassword;
